<template>
  <div id="app">
    <router-view v-if="this.$route.name === 'Login'"></router-view>
    <div v-if="this.$route.name !== 'Login'">
      <router-view></router-view>
      <router-view ref="footer" name="footer"></router-view>
    </div>
  </div>
</template>

<script>

export default {
  name: 'App',
}
</script>

<style>
html {
  width: 100%;
  max-width: 1024px;
  margin: 0 auto;
}

img {
  max-width: 100%;
  max-height: 100%;
}

body {
  background: #a80009;
}

.loadding {
  width: 100%;
  position: absolute;
  z-index: 98;
  top: 50%;
  left: 50%;
  text-align: center;
  transform: translate(-50%, -50%);
}

.loadding span {
  display: inline-block;
  width: 8px;
  height: 100%;
  border-radius: 4px;
  background: #ff7438;
  -webkit-animation: load 1.04s ease infinite;
}

.loadding span:nth-child(2) {
  -webkit-animation-delay: 0.13s;
}

.loadding span:nth-child(3) {
  -webkit-animation-delay: 0.26s;
}

.loadding span:nth-child(4) {
  -webkit-animation-delay: 0.39s;
}

.loadding span:nth-child(5) {
  -webkit-animation-delay: 0.52s;
}

@-webkit-keyframes load {

  0%,
  100% {
    height: 10px;
    background: #ff7438;
  }

  50% {
    height: 30px;
    margin-top: -20px;
    background: #ff7438;
  }
}
</style>